module.exports = __webpack_public_path__ + "img/archive.7b082193.svg";